export enum CRotation {
  /**
   * 旋转0度
   */
  ROTATION_0='',
  /**
   * 旋转90度
   */
  ROTATION_90='90',
  /**
   * 旋转180度
   */
  ROTATION_180='180',
  /**
   * 旋转270度
   */
  ROTATION_270='270',
}
